import { useCallback, useMemo } from 'react'

import { useToast } from '@driftt/dds'

/**
 * Returns functions to notify the user of success or error
 * @returns {object} { error: (message) => void, success: (message) => void }
 */
const useNotifications = () => {
  const triggerToast = useToast()

  const success = useCallback(
    (message) =>
      triggerToast({
        message: message,
        variant: 'success',
      }),
    []
  )

  const error = useCallback(
    (message) =>
      triggerToast({
        message: message,
        variant: 'error',
      }),
    []
  )

  return useMemo(() => ({ success, error }))
}

export default useNotifications
